import searchQueryLS from 'managers/localStorage/searchQuery/searchQueryLS';
import searchPropertiesKeys from 'state/_constants/searchPropertiesKeys';
import { resetSelectedOrigins } from '../actions';

export default function resetSelectedOriginsOperation() {
  return (dispatch) => {
    dispatch(resetSelectedOrigins());
    searchQueryLS.update(searchPropertiesKeys.SELECTED_ORIGINS_KEY, []);
  };
}
